import { useEffect, useRef, useState } from "react";

function ScriptRenderer({ html }) {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!html) {
      setLoading(false);
      return;
    }

    setLoading(true);

    // Create a temporary div to parse the HTML snippet
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Track number of scripts to load
    const scripts = tempDiv.querySelectorAll("script");
    let scriptsToLoad = scripts.length;

    const checkLoadingComplete = () => {
      scriptsToLoad -= 1;
      if (scriptsToLoad <= 0) setLoading(false);
    };

    scripts.forEach((script) => {
      const newScript = document.createElement("script");
      if (script.src) {
        newScript.src = script.src;
        newScript.async = script.async;
        newScript.onload = checkLoadingComplete;
        newScript.onerror = checkLoadingComplete; // handle errors
      } else {
        newScript.textContent = script.textContent;
        // inline scripts are already "loaded"
        checkLoadingComplete();
      }
      document.body.appendChild(newScript);
    });

    // Move non-script HTML into the container
    if (containerRef.current) {
      containerRef.current.innerHTML = "";
      Array.from(tempDiv.childNodes).forEach((node) => {
        if (node.tagName !== "SCRIPT") {
          containerRef.current.appendChild(node);
        }
      });
    }

    // Cleanup on unmount
    return () => {
      if (containerRef.current) containerRef.current.innerHTML = "";
    };
  }, [html]);

  return (
    <>
      {loading && <div>Loading widget...</div>}
      <div ref={containerRef} />
    </>
  );
}

export default ScriptRenderer;
